interface ZaalaLogoProps {
    size?: string | number;
    crossFill?: string;
}

export default function ZaalaLogo({ size = 64, crossFill = "#FFFFFF" }: ZaalaLogoProps) {
    const c = "#0277BD";

    return (
        <svg
            viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: size, height: size }}
        >
            {/* Clipboard body */}
            <rect x="12" y="16" width="56" height="58" rx="8" fill="none" stroke={c} strokeWidth="4" />

            {/* Clip */}
            <rect x="26" y="6" width="28" height="18" rx="4" fill={c} />

            {/* Cross cutout */}
            <rect x="36.5" y="8" width="7" height="14" rx="1.5" fill={crossFill} />
            <rect x="33" y="11.5" width="14" height="7" rx="1.5" fill={crossFill} />

            {/* Invoice lines */}
            <line x1="24" y1="34" x2="46" y2="34" stroke={c} strokeWidth="3" strokeLinecap="round" />
            <line x1="50" y1="34" x2="58" y2="34" stroke={c} strokeWidth="3" strokeLinecap="round" />

            <line x1="24" y1="44" x2="42" y2="44" stroke={c} strokeWidth="3" strokeLinecap="round" opacity="0.6" />
            <line x1="50" y1="44" x2="58" y2="44" stroke={c} strokeWidth="3" strokeLinecap="round" opacity="0.6" />

            <line x1="24" y1="54" x2="38" y2="54" stroke={c} strokeWidth="3" strokeLinecap="round" opacity="0.35" />
            <line x1="50" y1="54" x2="58" y2="54" stroke={c} strokeWidth="3" strokeLinecap="round" opacity="0.35" />

            {/* Divider */}
            <line x1="24" y1="62" x2="58" y2="62" stroke={c} strokeWidth="1" opacity="0.2" />

            {/* Total */}
            <line x1="24" y1="68" x2="36" y2="68" stroke={c} strokeWidth="3.5" strokeLinecap="round" />
            <line x1="48" y1="68" x2="58" y2="68" stroke={c} strokeWidth="3.5" strokeLinecap="round" />
        </svg>
    );
}
